import { Grid2 as Grid, Typography } from "@mui/material";

export const Header = () => (
  <Grid size="grow" sx={{ backgroundColor: "#EEF7F3", padding: 2 }}>
    <Typography sx={{ fontSize: "3rem" }} fontWeight="600" color="primary">
      Find a Unyte Provider
    </Typography>
  </Grid>
);
